var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.833,
    height: 20,
    viewBox: "0 0 10.833 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "multimedia",
    transform: "translate(128.17 0) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1028",
    "data-name": "Group 1028",
    transform: "translate(0 117.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M19.756,117.581a.832.832,0,0,0-1.178,0L10,126.158l-8.577-8.577a.833.833,0,1,0-1.178,1.178l9.166,9.166a.833.833,0,0,0,1.178,0l9.166-9.166A.832.832,0,0,0,19.756,117.581Z",
    transform: "translate(0 -117.336)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopBackArrow);
export default __webpack_public_path__ + "static/media/top-back-arrow.1ff44ac497549b28c9dc71ac0bb5e8bd.svg";
export { ForwardRef as ReactComponent };